import intl from 'react-intl-universal'

function getErrorMessageService(pharosService) {
  return function getErrorMessage(response, errorContext = '') {
    if (!response) {
      console.error(`getErrorMessage called with empty response object`)
      return intl.get('errorReasons.unspecifiedError')
    }
    const data = response.data || response
    if (!data.isError) {
      // AppErrors are valid handled errors and should not be logged to Sentry, only displayed in console
      if (
        data.isError === undefined ||
        !JSON.stringify(data).includes('AppError')
      ) {
        const message = `getErrorMessage called with non-error object`
        console.error(message, data)
        pharosService.sendExceptionToSentry(
          new Error(
            'getErrorMessage should be called with proper error object'
          ),
          message
        )
        return intl.get('errorReasons.unspecifiedError')
      }
      console.warn(
        'getErrorMessage called, however response is not an error',
        data
      )
      return ''
    }
    // Log received error to the console
    const logMessage = `${errorContext} ${JSON.stringify(data)}`
    console.error(logMessage)

    pharosService.sendErrorMessageToSentry({
      ...data,
      statusText: errorContext,
    })

    // Get alternate error as errorData (mostly string), or status text
    const alternateError =
      JSON.stringify(data.errorData) ||
      response.statusText ||
      intl.get('errorReasons.unspecifiedError')
    return intl
      .get(`errorReasons.${data.errorKey}`, data.errorData || {})
      .defaultMessage(alternateError)
  }
}

export default ['pharosService', getErrorMessageService]
